"use client";

import { useQuery } from "@tanstack/react-query";
import { useUniversalAuth } from "@wtc/ui";
import { Message } from "@/lib/core/crm/types";

export interface Attachment {
  id: string;
  name: string;
  size?: number;
  mimeType?: string;
}

export function useMessageAttachments(message: Message | null, enabled: boolean = true) {
  const { session } = useUniversalAuth();

  return useQuery({
    queryKey: ["message-attachments", message?.id],
    queryFn: async () => {
      if (!message) return [];

      const response = await fetch(
        `/api/messages/attachments?provider=${message.provider}&messageId=${message.providerMessageId}`,
        {
          headers: {
            Authorization: `Bearer ${session?.access_token}`,
          },
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to fetch attachments");
      }

      const data = await response.json();
      return data.attachments || [];
    },
    enabled: enabled && !!message && !!session?.access_token,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
